// © Microsoft Corporation. All rights reserved.
import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { DefaultButton, PrimaryButton, Stack } from '@fluentui/react';
import { VideoCameraEmphasisIcon } from '@fluentui/react-icons-northstar';
import { Spinner } from '@fluentui/react';
import {
  endCallTitleStyle,
  buttonStyle,
  buttonsStackTokens,
  videoCameraIconStyle,
  stackItemStyles,
  stackBtnItemStyles,
  stackStyles,
  stackStyless,
  fillstackItemStyles,
  questionStyle,
  Selectlabelnamep1,
  DescriptionSelecttext,
  sstackStyles,
  stackItemStyless,
  errormassagepanel
} from './styles/EndCall.styles';
import {
  setCallState
} from '../core/actions/calls';
import { Survey } from '../components/Survey';
import RadioInput from './RadioButtons';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import { saveSurvey } from '../core/chatSideEffects';

const mapDispatchToProps = (dispatch: any) => ({
  setCallState: async (msg: string) => dispatch(setCallState(msg))
});

const mapStateToProps = () => ({
});

export interface EndCallProps {
  message: string;
  rejoinHandler(): void;
  homeHandler(): void;
  setCallState(msg: string | null): any;
  darkColor: string;
  lightColor: string;
}

const EndCall = (props: EndCallProps): JSX.Element => {
  const [loader, setLoader] = useState(false);
  const [statement, setStatement] = useState("");
  // const [improve, setImprove] = React.useState('');
  const [howlong, setHowLong] = useState("");
  const [rating, setRating] = useState(0);
  const [satisfied13, setSatisfied13] = React.useState('');
  const [satisfied145, setSatisfied45] = React.useState('');
  const [coapplicant, setCoapplicant] = useState("");

  const [errorStatementMsg, setSErrorMsg] = useState(false);
  const [errorHLMsg, setHLErrorMsg] = useState(false);
  const [errorRMsg, setRErrorMsg] = useState(false);
  const [errorsatisfied13, setsatisfied13ErrorMsg] = useState(false);
  const [errorsatisfied45, setsatisfied145ErrorMsg] = useState(false);
  const [errorcoapplicant, setcoapplicantErrorMsg] = useState(false);

  // const disabled = (!statement || !howlong || !rating || !coapplicant) && (!satisfied13 || !satisfied145)
  // console.log(disabled)

  const defaultStatement = (value: any) => {
    setStatement(value);
    setSErrorMsg(false);
  }

  const defaultRating = (value: any) => {
    setRating(value);
    setRErrorMsg(false);
  }

  const defaultHowLong = (value: any) => {
    setHowLong(value);
    setHLErrorMsg(false);
  }

  const defaultCoapplicant = (value: any) => {
    setCoapplicant(value);
    setcoapplicantErrorMsg(false);
  }

  // const texthandleChanges = (event: any) => {
  //   setImprove(event.target.value);
  // };

  const texthandleChanges13 = (event: any) => {
    setSatisfied13(event.target.value);
    setsatisfied13ErrorMsg(false);
  };

  const texthandleChanges45 = (event: any) => {
    setSatisfied45(event.target.value);
    setsatisfied145ErrorMsg(false);
  };

  const submitSurvey = async () => {
    if (statement && howlong && rating && coapplicant && (satisfied13 || satisfied145)) {
      var data: any = {
        "Case_Number__c": sessionStorage.getItem('sfCaseNumber'),
        "Contact_Id__c": sessionStorage.getItem('sfContactId'),
        "Following_Statements__c": statement,
        "Time_taken_by_Duty_Officer__c": howlong,
        "Ratings__c": rating,
        "How_could_we_improve__c": (rating >= 1 && rating <= 3) ? satisfied13 : satisfied145,
        "How_likely_do_you_recommend_Connect_Now__c": coapplicant
      }
      setLoader(true);
      await saveSurvey(data);
      setLoader(false);
      props.homeHandler();
    } else {
      if (!statement) {
        setSErrorMsg(true);
      }
      if (!howlong) {
        setHLErrorMsg(true);
      }
      if (!rating) {
        setRErrorMsg(true);
        if (!satisfied13) {
          setsatisfied13ErrorMsg(true);
        }
        if (!satisfied145) {
          setsatisfied145ErrorMsg(true);
        }
      }
      if (rating) {
        if (!satisfied13) {
          setsatisfied13ErrorMsg(true);
        }
        if (!satisfied145) {
          setsatisfied145ErrorMsg(true);
        }
      }
      if (!coapplicant) {
        setcoapplicantErrorMsg(true);
      }
    }
  }

  return (
    <Fragment>
      {/* <Stack styles={stackStyles} style={{ float: 'left', width: '50%' }}>
        <Stack.Item styles={stackItemStyles}>
          <div className={endCallTitleStyle}>{props.message}</div>
        </Stack.Item>
        <Stack.Item styles={stackBtnItemStyles}>
          <Stack horizontal tokens={buttonsStackTokens} horizontalAlign="center" verticalAlign="center">
            <DefaultButton style={{ backgroundColor: '#438E8E', color: '#fff' }} className={buttonStyle} onClick={() => {
              props.rejoinHandler();
              props.setCallState('Connected');
            }}>
              <VideoCameraEmphasisIcon className={videoCameraIconStyle} size="medium" />
              {rejoinCall}
            </DefaultButton>
          </Stack>
        </Stack.Item>
      </Stack> */}
      {loader ? (
        <Spinner label={'Loading...'} ariaLive="assertive" labelPosition="top" style={{ marginTop: '100px' }} />
      ) : (
        <Fragment>
          <Stack styles={stackStyles}>
            <Stack.Item styles={stackItemStyles}>
              <div className={fillstackItemStyles}> <div className='mob_joining_lable'>Thank you for joining the call. Please fill out an Survey</div>  </div>
            </Stack.Item>
          </Stack>
          <Stack className='question_warpper_1' styles={stackStyless}></Stack>
          <Stack styles={stackStyless} className="question_warpper_2">
            {/* <Stack.Item styles={stackItemStyles}>
          <div className={questionStyle}>{'2. Was there anything we could improve?'}</div>
          <TextareaAutosize
            aria-label="minimum height"
            minRows={3}
            className={DescriptionSelecttext}
            autoComplete='off'
            onChange={texthandleChanges}
          />
        </Stack.Item> */}
            <Stack.Item styles={stackItemStyless}>
              <div className={questionStyle} style={{ marginBottom: '20px' }}>{'1. To what extent do you agree with the following statement :'}</div>
              <div className={questionStyle}>The connection process to the duty officer was simple, straightforward, and painless.</div>
              <div>
                <RadioInput
                  label=""
                  value={statement}
                  name={"statement"}
                  setValue={defaultStatement}
                  inputs={["Strongly agree", "Somewhat agree", "Neither agree nor disagree", "Somewhat disagree", "Strongly disagree"]}
                  darkColor={props.darkColor}
                />
              </div>
              {errorStatementMsg &&
                <span className={errormassagepanel}>Please Select the option</span>
              }
            </Stack.Item>
            <Stack.Item styles={stackItemStyless}>
              <div className={questionStyle}>{'3. How satisfied are you with the ConnectNow application?'}</div>
              <Survey
                message={'3. How satisfied are you with the ConnectNow application?'}
                darkColor={props.darkColor}
                defaultRating={defaultRating}
              />
              {errorRMsg &&
                <span className={errormassagepanel}>Please Select the rating</span>
              }
              {(rating >= 1 && rating <= 3) &&
                <Fragment>
                  <div className={questionStyle}>{'Sorry to hear that! How could we improve?'}</div>
                  <TextareaAutosize
                    aria-label="minimum height"
                    minRows={4}
                    className={DescriptionSelecttext}
                    autoComplete='off'
                    onChange={texthandleChanges13}
                  />
                  {errorsatisfied13 &&
                    <span className={errormassagepanel}>Please enter the comments</span>
                  }
                </Fragment>
              }
              {(rating > 3) &&
                <Fragment>
                  <div className={questionStyle}>{'What do you love about ConnectNow?'}</div>
                  <TextareaAutosize
                    aria-label="minimum height"
                    minRows={4}
                    className={DescriptionSelecttext}
                    autoComplete='off'
                    onChange={texthandleChanges45}
                  />
                  {errorsatisfied45 &&
                    <span className={errormassagepanel}>Please enter the comments</span>
                  }
                </Fragment>
              }
            </Stack.Item>
          </Stack>
          <Stack styles={stackStyless} className="question_warpper_3">
            <Stack.Item styles={stackItemStyless}>
              <div className={questionStyle}>{'2. How long did it take you to connect with the Duty Officer?'}</div>
              <div>
                <RadioInput
                  label=""
                  value={howlong}
                  name={"howlong"}
                  setValue={defaultHowLong}
                  inputs={["< 1 min", "1 to 3 min", "3 to 5 min", "5 to 10 min", "> 10 min"]}
                  darkColor={props.darkColor}
                />
              </div>
              {errorHLMsg &&
                <span className={errormassagepanel}>Please Select the option</span>
              }
            </Stack.Item>
            <Stack.Item styles={stackItemStyless}>
              <div className={questionStyle}>{'4. How likely are you to recommend ConnectNow application to your colleague?'}</div>
              <div>
                <RadioInput
                  label="Are you applying with someone else?"
                  value={coapplicant}
                  name={"Coapplicant"}
                  setValue={defaultCoapplicant}
                  inputs={["Very Likely", "Some What Likely", "Not Likely"]}
                  darkColor={props.darkColor}
                />
              </div>
              {errorcoapplicant &&
                <span className={errormassagepanel}>Please Select the option</span>
              }
            </Stack.Item>
          </Stack>
          <Stack styles={stackStyless}
            style={{ float: 'left', width: '10%' }}
          ></Stack>
          <Stack className='submit_button_mob' styles={sstackStyles}>
            <Stack.Item styles={stackBtnItemStyles}>
              <DefaultButton className={buttonStyle(props)} onClick={() => submitSurvey()}>
                Submit
              </DefaultButton>
            </Stack.Item>
          </Stack>
        </Fragment>
      )}
    </Fragment>
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(EndCall);